export default __webpack_public_path__ + "static/media/img17.8c546c99.JPG";